const SelectView = require('./selectview');

const PaneView = Backbone.View.extend({
    initialize: function (options) {
        this.options = options;
        this.parentView = options.parentView;
        this.isNew = false;
        this.btnTpl = JST.buttonTpl;
        this.statusTpl = JST.spanTpl;
        if (options.renderList) {
            this.renderList = options.renderList;
        }
        if (options.isNew) {
            this.isNew = options.isNew;
        }
    },
    events: {
        "change select\[name=\'address-countryID\'\]": "handleSelect",
        "click .btn": "handleClick"
    },
    handleSelect: function (e) {
        this.toggleShow($(e.target).val(), this.$el.find(".address-stateID, .address-zipCode"), this.$el.find(".address-province, .address-intlPostalCode"));
    },
    toggleShow: function (value, $elHide, $elShow) {
        // toggle State dropdown depending on country ID value.  232 == United States
        if (value === "232" || value === 232) {
            if ($elHide.hasClass("hide")) {
                $elHide.removeClass("hide");
            }
            if (!$elShow.hasClass("hide")) {
                $elShow.addClass("hide");
            }
        } else {
            $elHide.addClass("hide");
            if ($elShow.hasClass("hide")) {
                $elShow.removeClass("hide");
            }
        }
    },
    handleClick: function (e) {
        var $statusEl = this.$el.find(".status-block");
        switch ($(e.target).data("method")) {
            case "create":
                this.setValues(e);
                // parentView = phillips.TabsView
                this.parentView.collection.add(this.model);
                $statusEl.addClass("add").html("This address has been added.  Please make sure to click 'Save/Add' below to save all changes");
                break;
            case "update":
                this.setValues(e);
                $statusEl.addClass("update").html("This address has been updated.  Please make sure to click 'Save/Add' below to save all changes");
                break;
            case "delete":
                // parentView = phillips.TabsView
                this.parentView.collection.remove(this.model);
                this.parentView.removePane(this);
                break;
            default:
                break;
        }
    },
    render: function () {
        // loop through renderList given from View, ie: Locations
      _.forEach(this.renderList, function (item, i) {
            // add select dropdown passing in collection of descriptions and values
            if (item.inputType === "select") {
                // ie: States & Countries
                item.view = new SelectView({
                    el: this.el,
                    collection: item.list,
                    "modelKey": item.modelKey
                });
            } else {
                this.$el.append(item.template(item));
            }
            if (item.className) {
                this.$el.find("#" + item.modelKey).addClass(item.className);
            }
        }, this);
        // map values for existing models
        if ((this.parentView.callType === "edit") && (this.isNew !== true)) {
            this.getValues();
        }
        if (this.isNew === true) {
            this.toggleShow(0, this.$el.find(".address-stateID, .address-zipCode"), this.$el.find(".address-province, .address-intlPostalCode"));
        }
        this.addButtons();
    },
    setValues: function (e) {
        var formObj = {},
          prop0 = "",
          prop1 = "",
          arrOfProps = [];
        $(e.target).siblings("input, select").serializeArray().map(function (obj) {
            if (obj.name.indexOf("-") !== -1) {
                arrOfProps = obj.name.split("-");
                prop0 = arrOfProps[0];
                prop1 = arrOfProps[1];
                if (typeof formObj[prop0] === "undefined") {
                    formObj[prop0] = {};
                }
                formObj[prop0][prop1] = obj.value;
            } else {
                formObj[obj.name] = obj.value;
            }
        });
        // hack for radio buttons
        if ($(e.target).siblings(".form-group").length > 0) {
            $(e.target).siblings(".form-group").each(function (i, el) {
                $(el).find("input[type='radio']").each(function (j, input) {
                    if ($(input).prop("checked")) {
                        formObj[input.name] = input.value;
                    }
                });
            });
        }
        for (var prop in formObj) {
            if (formObj.hasOwnProperty(prop)) {
                if (typeof formObj[prop] === "object") {
                    this.model.get(prop).set(formObj[prop]);
                }
                else {
                    var objData = {};
                    objData[prop] = formObj[prop];
                    this.model.set(objData);
                }
            }
        }
        console.log(formObj);
        console.log(this.model);
    },
    getValues: function () {
        var countryID = null;
      _.forEach(this.renderList, function (item, i) {
            var prop0 = "",
              prop1 = "",
              inputVal = "",
              arrOfProps = [];
            if (item.modelKey.indexOf("-") !== -1) {
                arrOfProps = item.modelKey.split("-");
                prop0 = arrOfProps[0];
                prop1 = arrOfProps[1];
                inputVal = this.model.get(prop0).get(prop1);
            } else {
                prop0 = item.modelKey;
                inputVal = this.model.get(prop0);
            }
            switch (item.inputType) {
                case "text":
                    this.$el.find("#" + item.modelKey).val(inputVal);
                    break;
                case "select":
                    this.$el.find("." + item.modelKey).children("option\[value=\'" + inputVal + "\'\]").prop("selected", true);
                    if (item.modelKey === "address-countryID") {
                        countryID = inputVal;
                    }
                    if (item.modelKey === "address-stateID") {
                        this.toggleShow(countryID, this.$el.find(".address-stateID, .address-zipCode"), this.$el.find(".address-province, .address-intlPostalCode"));
                    }
                    break;
                case "radio":
                    this.$el.find("input\[name=\'" + item.modelKey + "\'\]\[value=\'" + inputVal + "\'\]").prop('checked', true);
                    break;
                default:
                    break;
            }
            // console.log(prop0, prop1);
            // if (item.inputType === "select") {
            //   item.view = new SelectView({
            //     el: this.el,
            //     collection: item.list,
            //     "modelKey": item.modelKey
            //   });
            // } else {
            //   this.$el.append(item.template(item));
            // }
        }, this);
        //if (this.collection.length > 0) {
        //  _.forEach(this.collection.models, function (item, i) {
        //    this.$elPanes.find("#address" + i).children().each(function (j, input) {
        //      var address = item.get("address");
        //      $(input).val(address.get($(input).attr("name")));
        //    });
        //  }, this);
        //}
    },
    addButtons: function () {
        if (this.isNew !== true) {
            this.$el.append(this.btnTpl({
                "btnClass": "btn-primary",
                "method": "update",
                "label": "Update"
            }));
            this.$el.append(this.btnTpl({
                "btnClass": "btn-danger",
                "method": "delete",
                "label": "Delete"
            }));
        } else {
            this.$el.append(this.btnTpl({
                "btnClass": "btn-success",
                "method": "create",
                "label": "Add"
            }));
        }
        this.$el.append(this.statusTpl({
            "className": "status-block"
        }))
    },
    destroy: function () {
        this.undelegateEvents();
        $(this.el).removeData().unbind();
        this.remove();
    }
});

export default PaneView;
